import { useIsVirtualBackgroundEnabled } from './useIsVirtualBackgroundEnabled';
import { getVirtualBackgroundFromLocalStorage } from '../../components/media/virtualBackground';
import { useGetUserId } from '../../hooks/useCredentials';

export const useVirtualBackgroundName = (): string | null => {
  const userId = useGetUserId();
  const isVirtualBgEnabled = useIsVirtualBackgroundEnabled();

  const storedBackground =
    Boolean(userId) && getVirtualBackgroundFromLocalStorage(userId);

  if (!isVirtualBgEnabled || !storedBackground) {
    return null;
  }

  return storedBackground.name === 'None' ? null : storedBackground.name;
};
